/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setFavReportObj } from 'store/auth/Authslice';

import FavoriteDashboards from '../../home/favorites/FavoriteDashboards';

import classes from './FavoriteDashboards.module.scss';

import axiosDBClient from 'axiosDBClient';
import LinkButton from 'components/shared/button/LinkButton';
import LinkList from 'components/shared/List/LinkList';

import { FAVORITE_DASHBOARD_DEFAULT_TEXT } from 'constants/constants';
const Favorites = () => {
  const dispatch = useDispatch();
  const favorites = useSelector((state) => state.Auth.favReportObj);
  const { unixId, roleId } = useSelector((state) => state.Auth.userClaimObject);

  const [modalShow, setModalShow] = useState(false);
  const favoritesData = JSON.parse(JSON.stringify(favorites));

  const [reportsData, setReportData] = useState(favoritesData);
  const [updatedReports, setUpdatedReports] = useState([]);
  const showFavorites =
    favorites && favorites?.some((item) => item?.isFavorite === 'Y');

  useEffect(() => {
    const tempReport = [...reportsData];

    tempReport?.sort((a, b) => a?.reportName?.localeCompare(b.reportName));
    setReportData(tempReport);
  }, [dispatch]);

  const favoriteClickHandler = () => {
    setModalShow(true);
  };

  const onSave = () => {
    const filteredData = reportsData.filter(
      (report) => updatedReports.indexOf(report.reportID) !== -1
    );

    if (filteredData?.length === 0) {
      return;
    }

    axiosDBClient
      .post(
        'report/favorites',
        {
          userId: unixId,
          reports: filteredData,
          roleId: roleId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then(() => {
        dispatch(setFavReportObj(reportsData));
      })
      .catch((err) => {
        console.log(err);
      });

    setUpdatedReports([]);
    setModalShow(false);
  };

  const onHide = () => {
    setUpdatedReports([]);
    setReportData(favoritesData);
    setModalShow(false);
  };

  return (
    <>
      <p className='title__normal title__bold d-flex align-items-center'>
        <i className='icon icon__favorite m-1'></i>
        <span className={`${classes['left-align']}`}> Favorite Dashboards</span>

        <LinkButton
          className='ms-2 me-0'
          onClick={favoriteClickHandler}>
          <i className='icon icon__edit m-0'></i>
        </LinkButton>
      </p>

      <FavoriteDashboards
        show={modalShow}
        onSave={onSave}
        onHide={onHide}
        reportsData={reportsData}
        setReportData={setReportData}
        updatedReports={updatedReports}
        setUpdatedReports={setUpdatedReports}
      />

      {showFavorites && <LinkList items={reportsData} />}
      {!showFavorites && <p>{FAVORITE_DASHBOARD_DEFAULT_TEXT}</p>}
    </>
  );
};

export default Favorites;
